import { gql } from '@apollo/client'
import React from 'react'

import { stocksClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useModalData } from '../../../../components/modals/ModalsContext'

const Context = React.createContext([])
const { Provider } = Context
export const useStockItemState = () => React.useContext(Context)
export const useStockItem = () => useStockItemState()?.stockItem

const QUERY = gql`
  query StockItem($id: ID) {
    stockItem(id: $id) {
      id
      name
      amount
      warningAmount
      criticalAmount
      code
      description
      category
      subCategory
      brand
      model
      supplier
      sizeUnit
      minAmount
      maxAmount
      location
      purchaseTax
      purchasePrice
      salesPrice
      maxDiscount
      salesTax
      currency
      barCode
      notes
      enabled
      notificationEmails
      documents {
        id
        src
        type
      }
    }
  }
`

const StockItemLoader = ({ children }) => {
  const id = useModalData()
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: stocksClient,
    fetchPolicy: 'no-cache'
  })

  const formattedData = {
    ...data,
    stockItem: {
      ...data?.stockItem,
      notificationEmails: data?.stockItem?.notificationEmails?.join('; ') ?? ''
    }
  }

  return (
    <StatePresenter {...state}>
      <Provider value={formattedData}>{children}</Provider>
    </StatePresenter>
  )
}

export default StockItemLoader
